import findAllButById from 'helpers/findAllButById'

export default function replaceCamera({ state, id, updatedCamera }) {
  return Object.assign({}, state, {
    cameras: findAllButById({ state: state.cameras, id }).concat(updatedCamera)
  })
}



// WEBPACK FOOTER //
// ./src/helpers/cameras/replaceCamera.js